import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackAction } from '../../services/activityService';
import { User } from '../../services/authService';

interface TrackedRouteProps {
    children: React.ReactNode;
    user: User | null;
}

const TrackedRoute: React.FC<TrackedRouteProps> = ({ children, user }) => {
    const location = useLocation();

    useEffect(() => {
        trackAction(user, 'PAGE_VIEW', {
            path: location.pathname,
            search: location.search,
        });
    }, [location, user]);

    return <>{children}</>;
};

export default TrackedRoute;
